import React from 'react';
import styled from 'styled-components';
import { DefaultEmptyKeyEventsAndIntervalsEmptyTable } from 'components/organisms/template-insight/empty-state';
import { useTranslate } from 'hooks/use-translation';
import { useIntervals } from 'utils/project-fields/use-project-fields';
import { ChartTypes, KeyEventsAndIntervalsChart } from '../charts';
import { useIntervalReport } from '../use-interval-report';
import { OverviewViewTable } from './table';
import { computeChartData } from './utils';

const Wrapper = styled.div`
  overflow: auto;
  height: 100%;
  background: var(--coolest-gray-10);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  padding: var(--spacing-05);
`;

const groupBy = { monthly: 'MONTH', weekly: 'WEEK' };

export const OverviewView = ({
  filter,
  selectedRange,
  viewInitialized,
  zoomLevel,
}) => {
  const intervals = useIntervals();

  const intervalsMapping =
    intervals.reduce((acc, curr) => {
      if (curr.fieldType === 'INTERVALS' && curr.metaData?.relatedFieldId) {
        return { ...acc, [curr.fieldId]: curr };
      }

      return acc;
    }, {}) ?? {};

  const intervalReportData = useIntervalReport(
    selectedRange,
    filter,
    groupBy[zoomLevel],
    viewInitialized,
  );

  const translate = useTranslate();

  const { absoluteValueChartOptions, deviationChartOptions } = computeChartData(
    intervalReportData[1] ?? [],
    zoomLevel,
    intervalsMapping,
    translate,
  );

  const isLoading = intervalReportData[0] === 'loading';

  return (
    <Wrapper>
      <KeyEventsAndIntervalsChart
        chartOptions={absoluteValueChartOptions}
        chartType={ChartTypes.IntervalAsAbsoluteValue}
        isLoading={isLoading}
      />
      <KeyEventsAndIntervalsChart
        chartOptions={deviationChartOptions}
        chartType={ChartTypes.IntervalAsDeviation}
        isLoading={isLoading}
      />

      <OverviewViewTable
        renderEmpty={() =>
          DefaultEmptyKeyEventsAndIntervalsEmptyTable({
            noDataDescriptionKey:
              'reports.intervals.table.listOfIntervals.empty.description',
          })
        }
        filter={filter}
        selectedRange={selectedRange}
        isLoading={isLoading}
        intervalReportData={intervalReportData[1] ?? []}
        absoluteValueOptions={absoluteValueChartOptions}
        zoomLevel={zoomLevel}
      />
    </Wrapper>
  );
};
